import {useQuery} from "@tanstack/react-query";
import {checkAliasService} from "../services/account/checkAlias.service";

const useCheckAlias = (alias, enabled = false) => {
  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["checkAlias", alias],
    queryFn: () => checkAliasService(alias),
    enabled: Boolean(alias) && enabled, // Only run when alias exists and is explicitly enabled
    refetchOnWindowFocus: false,
    retry: false,
  });

  // Format the data for easier consumption by components
  const exists = data?.data?.data?.exists ?? false;
  const checkedAlias = data?.data?.data?.alias ?? "";

  return {
    isAliasAvailable: !exists,
    checkedAlias,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export default useCheckAlias;
